/**
 * Les gestes de la semaine des lives, ceux de l'ancienne carte (`TutorLiveCardComponent`) :
 *  - « GO ! » → `pre-call` le jour du live, sinon la boîte « accessible le jour même »
 *    (`useTutorJoinSession`, le même que l'accueil) ;
 *  - une séance sans demande → `move-session` (l'ancien « GÉRER LES RDV ») ;
 *  - une séance qui porte une demande ouvre sa boîte (`useTutorSessionNotice`, celle de « Ma
 *    journée ») : « Annuler la demande » annule le retard ou le remplacement, « Impossible
 *    d'annuler » sur un refus 400, « Contacter le support » ouvre le WhatsApp de l'équipe ;
 *  - la croix → retour, ou l'accueil (`menu`) quand la pile est vide (l'ancien `next-lives`).
 */
import { useNavigation } from "@react-navigation/native"

import { type UITutorHomeSession } from "../../../../adapters/tutor/Home/tutorSessionAdapter"
import { type UITutorWeekSession } from "../../../types/tutorLives"
import { useBackOr } from "../../../hooks/useBackOr"
import { useOpenTutorSupport } from "../useOpenTutorSupport"
import { useTutorJoinSession } from "./useTutorJoinSession"
import { useTutorSessionNotice } from "./useTutorSessionNotice"

type StackNavigation = { push: (route: string, params?: object) => void }

/** L'écran d'où partent les gestes, en propriété `surface` de leur mesure. */
const SURFACE = "tutor_lives"

/** La page rend les séances qu'on lui a passées : celles du view-model, qui portent leurs ids d'action. */
const asSession = (session: UITutorWeekSession) => session as UITutorHomeSession

export function useTutorLivesListState() {
    const navigation = useNavigation() as unknown as StackNavigation
    const notice = useTutorSessionNotice(SURFACE)
    const openSupport = useOpenTutorSupport()
    const close = useBackOr("menu")
    const join = useTutorJoinSession<UITutorWeekSession>()

    return {
        onClose: close,
        onSelectSession: (session: UITutorWeekSession) => {
            if (!notice.open(asSession(session))) navigation.push("move-session", { liveId: session.id })
        },
        ...join,
        sessionNotice: notice.sessionNotice,
        onCancelSessionRequest: notice.cancelRequest,
        onCloseSessionNotice: notice.close,
        onContactSupport: () => openSupport(),
    }
}
